<template>
  <ZigzagServiceLayout
    mainTitle="OtoModelagem de Orelha e Rejuvenescimento do Lóbulo"
    mainDescription="Na Diverse Care Now, oferecemos procedimentos minimamente invasivos projetados para remodelar, rejuvenescer e restaurar suas orelhas — sem necessidade de cirurgia tradicional. Tempo de recuperação mínimo com cuidado profissional."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EarLobeRepairContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'OTOMODELAGEM',
          title: 'OtoModelagem de Orelha (Remodelação Sem Incisões)',
          subtitle: 'Remodele e reposicione orelhas proeminentes sem cirurgia extensa.',
          paragraphs: [
            "A OtoModelagem é um procedimento minimamente invasivo projetado para remodelar e reposicionar orelhas proeminentes sem a necessidade de cirurgia extensa. O procedimento é realizado utilizando suturas internas permanentes que remodelam a cartilagem da orelha e criam um contorno mais natural enquanto preservam a anatomia da orelha.",
            "O procedimento é realizado no consultório sob anestesia local, permitindo que os pacientes permaneçam acordados e confortáveis durante o tratamento. Como não são necessárias grandes incisões, a recuperação é tipicamente mais rápida do que com a otoplastia tradicional, com menos inchaço e tempo de inatividade mínimo."
          ],
          list: [
            "Técnica minimamente invasiva",
            "Realizado sob anestesia local",
            "Suturas internas permanentes para remodelar a orelha",
            "Não requer anestesia geral",
            "Cicatrização mínima",
            "Tempo de recuperação curto",
            "Resultados de aparência natural"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/9rbA47bOvms'
          ]
        },
        {
          label: 'REJUVENESCIMENTO',
          title: 'Rejuvenescimento do Lóbulo com Preenchimentos Dérmicos',
          subtitle: 'Restaure o volume e a aparência jovem dos lóbulos envelhecidos.',
          paragraphs: [
            "À medida que envelhecemos, os lóbulos das orelhas perdem naturalmente colágeno, elastina e gordura, fazendo com que pareçam mais finos, desinflados ou alongados. Essa perda de volume também pode resultar de anos usando brincos pesados.",
            "Na Diverse Care Now, utilizamos preenchimentos dérmicos de ácido hialurônico para restaurar o volume perdido, melhorar o contorno e rejuvenescer a aparência dos lóbulos. O tratamento cria um visual mais cheio, suave e jovem, proporcionando melhor suporte para brincos."
          ],
          list: [
            "Restaura a perda de volume relacionada à idade",
            "Melhora a forma e o contorno dos lóbulos",
            "Cria uma aparência mais jovem",
            "Proporciona melhor suporte para brincos",
            "Procedimento de consultório rápido e minimamente invasivo"
          ],
          image: '/images/services/earlobe-repair.png'
        }
      ]
    };
  }
};
</script>
